<script lang="ts">
  import { addToast } from '../toast/store.js';

  import Modal from '../Modal.svelte';
  import Text from '../Text.svelte';
  import Table from '../Table.svelte';
  import { Redirect } from '../../utils/redirect.service.js';

  import type { Row, Column } from '../Table.svelte';
  import { getUserErrorMessage } from 'src/utils/error.js';

  export let isOpen: boolean;
  export let redirect: Redirect | undefined;
  export let getRedirectLogs: (redirectId: number) => Promise<Row[]>;

  let logs: Row[] = [];

  const columns: Column[] = [
    {
      label: 'Action',
      sortable: false,
      field: 'action'
    },
    {
      label: 'Zeitpunkt',
      sortable: false,
      field: 'created_at',
      formatter: rawFieldContent => new Date(rawFieldContent).toLocaleString('de-de')
    },
    {
      label: 'User',
      sortable: false,
      field: 'username'
    }
  ];

  const resetLogs = () => {
    logs = [];
  };

  const getLogs = async () => {
    if (redirect && isOpen) {
      try {
        const data = await getRedirectLogs(redirect.id);
        logs = data;
      } catch (e) {
        addToast({
          type: 'error',
          message: getUserErrorMessage(e, 'Fehler beim Abrufen der Redirect-Logs')
        });
      }
    }
  };

  $: isOpen, getLogs();
</script>

{#if redirect}
  <Modal
    size="small"
    label={`Logs zum Redirect mit ID ${redirect.id}`}
    bind:isOpen
    onClose={resetLogs}
  >
    <div slot="fixed">
      <Text size="small">Quelle: {redirect.source}</Text>
      <Text size="small">Ziel: {redirect.destination}</Text>
    </div>
    <Table rows={logs} {columns} />
  </Modal>
{:else}
  <Modal size="small" label={`Keine Logs gefunden`} bind:isOpen onClose={resetLogs}>
    <Text>Unter der von Ihnen angefragten Redirect-ID konnten keine Logs gefunden</Text>
  </Modal>
{/if}
